// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".translateZ[data-v-62ac4497]{transform:translateZ(1px)}.panel-icon[data-v-62ac4497]{width:32px;height:4px;background:#979ca1 0 0 no-repeat padding-box;border-radius:6px}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
